import React, { useRef, useState, useEffect } from "react";
import {Row,Col} from 'reactstrap';
import { useAuth } from "../Context/AuthContext";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";

export default function DeleteUser() {
  //refs contain current.value
  const emailRef = useRef();
  const passwordRef = useRef();
  //destructure from auth
  const { login,deleteUserFromDatabase } = useAuth();
  //hooks
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  //redirect
  const dispatch = useDispatch();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      let isMounted = true;
      if (isMounted) {
        //reset error
        setError("");
        //set loading state
        setLoading(true);
        //signing up with email and password
        await login(emailRef.current.value, passwordRef.current.value);
        deleteUserFromDatabase()
        
      }
      isMounted = false;
    } catch {
      setError("Kontrollera din email och ditt lösenord.");
    }
    //stop loading state
    setLoading(false);
  }
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Login"));
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);


  return (
    <Row className="mt-5 d-flex align-items-center justify-content-center">
      <Col xs={20}>

        <Row>
          <Col 
            xs={20} 
            className="offset-17 lead fw-bold text-muted responsive-fontsize"
            style={{cursor:'default'}}
          >
            Ta bort användare
          </Col>
        </Row>

        {error ? 
          <Row>
            <Col 
              xs={40} 
              className="text-center text-danger responsive-fontsize"
              style={{cursor:'default'}}
            >
              {error}
            </Col>
          </Row>
        : ""}    

        <form onSubmit={handleSubmit}>

          <Row className="mt-3">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              E-mail:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input type="email" className="form-control" required ref={emailRef} autoComplete="off"/>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col 
              xs={10} 
              className="offset-7 d-flex align-items-center justify-content-end responsive-fontsize"
              style={{cursor:'default'}}
            >
              Lösenord:
            </Col>
            <Col xs={15} className="d-flex align-items-center justify-content-start">
              <input
                type="password"
                className="form-control"
                required
                ref={passwordRef}
                autoComplete="new-password"
              />
            </Col>
          </Row>
          <Row className="mt-2">
          <Col xs={23} className="offset-17 responsive-fontsize" style={{cursor:'default', color:"red"}}> 
            Detta tar bort all din data från vår databas! 
          </Col>
        </Row>  
        <Row className="mt-1">
          <Col xs={23} className="offset-17 responsive-fontsize" style={{cursor:'default', color:"red"}}> 
            Borttagen data kan ej återställas.
          </Col>
        </Row> 
          <Row>
            <Col xs={20} className="offset-17 mt-3">
              <button
                type="submit"
                className="btn btn-success responsive-fontsize"
                //when loading is true button is disabled, prevents multiple clicks when signing up
                disabled={loading}
              >
                Ta bort användare och all data
              </button>
            </Col>
          </Row>
        </form>

        <Row className="mt-5">
          <Col xs={23} className="offset-17 responsive-fontsize" style={{cursor:'default'}}> 
            Gå tillbaka till Logga in ? <Link to="/login" className="ps-2 fw-bold">Logga in</Link>   
          </Col>
        </Row>       

      </Col>    
    </Row>
  );
}














/*
<div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h2>Välkommen till Lönsamhetsmodulen!</h2>
        {error ? <div>{error}</div> : ""}
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <label>
            Email
            <input type="email" required ref={emailRef} />
          </label>
          <label>
            Lösenord
            <input
              type="password"
              required
              ref={passwordRef}
              autoComplete="off"
            />
          </label>
          <button
            type="submit"
            //when loading is true button is disabled, prevents multiple clicks when signing up
            disabled={loading}
          >
            Logga in
          </button>
        </form>
        <div>
          Har du inget konto? <Link to="/signup">Skapa ett konto</Link>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "10%",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Har du glömt ditt lösenord?
          <div style={{ display: "flex", flexDirection: "row" }}>
            <label>
              Email
              <input type="email" required ref={resetEmailRef} />
            </label>
            <input
              type="button"
              onClick={() =>
                resetPassword(resetEmailRef.current.value.toString())
              }
              value="Återställ lösenord"
            />
          </div>
        </div>
      </div>
*/